import { AppData, RawAppData } from '@/types/app';

export const decodeAppData = (raw: RawAppData): AppData => ({
  apiUrl: raw.apiUrl,
  listings: raw.listings,
  uiConfig: raw.uiConfig,
  translations: raw.translations,
  partnerLinks: {
    tosUrl: raw.partnerLinks.tos_url,
    contactUrl: raw.partnerLinks.contact_url,
    privacyUrl: raw.partnerLinks.privacy_url,
  },
  listingId: raw.listingId,
  membershipConfig: raw.membershipConfig,
  messages: {
    customMessages: raw.messages.custom_messages,
    finalMessages: raw.messages.final_messages,
  },
});
